  (function () {
    if (!window.__bhReveal) {
      window.__bhReveal = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var run = function () {
        var els = document.querySelectorAll('.bh-reveal, .bh-settle');
        if (reduce.matches || !('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) els[i].classList.add('is-in'); return; }
        document.documentElement.classList.add('bh-motion');
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        els.forEach(function (el) { io.observe(el); });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    }
  })();

// Blaq Coffee - Standing Order / Gift term PDP configurator.
// Combines the design's live total calculation (blaq-term-config.js: unit x qty x
// deliveries -> [data-out="total"]) with the theme's real add-to-cart pattern
// (blaq-subscribe.js): the chosen Selection x Size is matched against
// window.__blaqTermVariants to resolve the variant id, a selling plan whose
// delivery interval is MONTH is chosen for the term, and a JSON body is posted
// to /cart/add.js. A graceful one-time fallback keeps the bag from breaking when
// a variant carries no plan. The running plan-card total is the ONLY price shown.
(function () {
  var root = document.querySelector('[data-term-config]');
  if (!root) return;

  var deliveries = parseInt(root.getAttribute('data-deliveries'), 10) || 1;

  // ---- live label + total -------------------------------------------------
  function activeIn(group) {
    return root.querySelector('[data-group="' + group + '"] .bh-opt-pill.active');
  }
  function setOut(name, text) {
    var els = document.querySelectorAll('[data-out="' + name + '"]');
    if (!els || !els.length) return;
    for (var i = 0; i < els.length; i++) els[i].textContent = text;
  }
  function render() {
    var sel = activeIn('selection');
    var size = activeIn('size');
    if (sel) setOut('selection', sel.getAttribute('data-label') || sel.getAttribute('data-value') || '');
    if (size) setOut('size', size.getAttribute('data-label') || size.getAttribute('data-value') || '');
    if (sel && size) {
      var coffee = sel.getAttribute('data-value'), boxes = size.getAttribute('data-value');
      var mv = (window.__blaqTermVariants || []).filter(function (v) { return v.c === coffee && v.b === boxes; })[0];
      var total;
      if (mv && mv.price != null) {
        total = mv.price * deliveries;
      } else {
        var unit = parseInt(sel.getAttribute('data-price'), 10) || 0;
        var qty = parseInt(size.getAttribute('data-qty'), 10) || 1;
        total = unit * qty * deliveries;
      }
      setOut('total', String(total));
    }
  }

  // ---- pill toggles -------------------------------------------------------
  var groups = root.querySelectorAll('[data-group]');
  for (var g = 0; g < groups.length; g++) {
    (function (group) {
      var pills = group.querySelectorAll('.bh-opt-pill');
      for (var p = 0; p < pills.length; p++) {
        (function (pill) {
          pill.addEventListener('click', function () {
            for (var k = 0; k < pills.length; k++) {
              pills[k].classList.toggle('active', pills[k] === pill);
            }
            render();
          });
        })(pills[p]);
      }
    })(groups[g]);
  }
  render();

  // ---- selling plan: prefer a MONTH interval, else first, else one-time ----
  // Plans carry only { id, name } (storefront Liquid does not expose interval/count),
  // so the interval is parsed from the plan name (e.g. "Every Month" -> MONTH),
  // mirroring planMeta in blaq-subscribe.js. If multiple plans ever exist, a
  // MONTH-interval plan is preferred; otherwise fall back to the first plan.
  function planMeta(name) {
    var m = (name || '').toLowerCase().match(/(\d+)?\s*(day|week|month|year)/);
    return m ? m[2].toUpperCase() : '';
  }
  function pickPlanId(variant) {
    var plans = (variant && variant.plans) || [];
    if (!plans.length) return ''; // no plan on this variant: one-time purchase (see body note below)
    for (var i = 0; i < plans.length; i++) {
      // Prefer an explicit interval field if a future data source ever provides one,
      // then fall back to parsing the plan name for a MONTH interval.
      var interval = ((plans[i].interval || '') + '').toUpperCase() || planMeta(plans[i].name);
      if (interval === 'MONTH') return plans[i].id;
    }
    return plans[0].id; // graceful fallback: still a subscription, nearest plan
  }

  // ---- add to bag ---------------------------------------------------------
  var addBtn = root.querySelector('.bh-btn-pill[data-add]') || root.querySelector('[data-add]') || document.querySelector('.bh-btn-pill[data-add]') || document.querySelector('[data-add]');
  var addedNote = root.querySelector('[data-added]') || document.querySelector('[data-added]');
  var noteField = document.querySelector('[data-field="note"]');
  var termValue = '';
  var termOut = root.querySelector('[data-out="term"]');
  if (termOut) termValue = (termOut.textContent || '').trim();
  if (!termValue) termValue = String(deliveries) + ' deliveries';

  // ---- inline warning -----------------------------------------------------
  // Mirrors the theme's own '.cart-warning' pattern rather than a native alert():
  // the message is rendered quietly beneath the button, in place. Created lazily
  // and reused. If there is no button to anchor to, fall back to alert() so the
  // shopper is never left without the message.
  var warnEl = null;
  function warnTarget() {
    if (warnEl && warnEl.parentNode) return warnEl;
    if (!addBtn || !addBtn.parentNode) return null;
    warnEl = root.querySelector('[data-term-warning]') || document.querySelector('[data-term-warning]');
    if (!warnEl) {
      warnEl = document.createElement('p');
      warnEl.className = 'cart-warning';
      warnEl.setAttribute('data-term-warning', '');
      warnEl.setAttribute('role', 'status');
      warnEl.setAttribute('aria-live', 'polite');
      addBtn.parentNode.insertBefore(warnEl, addBtn.nextSibling);
    }
    return warnEl;
  }
  function showWarning(message) {
    var el = warnTarget();
    if (!el) { alert(message); return; }
    el.textContent = message;
    el.hidden = false;
    el.style.display = '';
  }
  function clearWarning() {
    if (!warnEl) return;
    warnEl.textContent = '';
    warnEl.hidden = true;
    warnEl.style.display = 'none';
  }

  if (addBtn) {
    var label = addBtn.textContent;
    addBtn.addEventListener('click', function () {
      clearWarning();
      var sel = activeIn('selection');
      var size = activeIn('size');
      var variants = window.__blaqTermVariants || [];
      var coffee = sel ? (sel.getAttribute('data-value') || '') : '';
      var boxes = size ? (size.getAttribute('data-value') || '') : '';

      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].c === coffee && variants[i].b === boxes) { match = variants[i]; break; }
      }
      if (!match) {
        showWarning('That arrangement is not available right now. Please choose another selection.');
        return;
      }

      var props = { 'Term': termValue };
      if (noteField) {
        var note = (noteField.value || '').trim();
        if (note) props['Recipient note'] = note;
      }
      var dateField = document.querySelector('[data-field="deliver_on"]');
      if (dateField) {
        var when = (dateField.value || '').trim();
        if (when) props['First box to land'] = when;
      }

      var planId = pickPlanId(match);
      var body = { id: match.id, quantity: 1, properties: props };
      // Intentional one-time fallback: when the variant carries ZERO selling plans,
      // planId is '' and no selling_plan is attached, so the item is added as a
      // one-time purchase by design (these term products currently all carry exactly
      // one plan). If a variant has plans but none is MONTH, pickPlanId still returns
      // the first plan above, so a prepaid term never silently loses its subscription.
      if (planId) body.selling_plan = planId;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
        .then(function () {
          if (addedNote) {
            addedNote.classList.add('show');
            clearTimeout(addBtn._t);
            addBtn._t = setTimeout(function () { addedNote.classList.remove('show'); }, 3600);
          }
          // Refresh the cart view + badge and open the drawer using the theme's real
          // ajax-cart API (z__jsAjaxCart.js). updateView() re-renders the drawer and sets
          // [data-bind="itemCount"] from a fresh cart section fetch; showDrawer() slides it in.
          var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart;
          if (ajaxCart && typeof ajaxCart.updateView === 'function') { ajaxCart.updateView(); }
          if (ajaxCart && typeof ajaxCart.showDrawer === 'function') { ajaxCart.showDrawer(); }
          // Resilient fallback: if the ajax-cart API is unavailable or its name differs,
          // still set the header badge directly from a fresh /cart.js item_count.
          if (!ajaxCart || typeof ajaxCart.updateView !== 'function') {
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (c) {
                var badges = document.querySelectorAll('[data-bind="itemCount"]');
                for (var i = 0; i < badges.length; i++) badges[i].textContent = c.item_count;
              })
              .catch(function () {});
          }
        })
        .catch(function (err) {
          showWarning((err && err.description) || 'Could not add this to your bag. Please try again.');
        })
        .finally(function () {
          addBtn.disabled = false;
          addBtn.textContent = label;
        });
    });
  }
})();
